import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { OPEN_WITH_FAIRE_TOTAL_APPLICATION_COUNT } from "@faire/web-api--source/indigofair/settings/OPEN_WITH_FAIRE_TOTAL_APPLICATION_COUNT";

export const getSettingOpenWithFaireTotalApplicationCount = () =>
  getSettingValueWithoutAssignment(
    OPEN_WITH_FAIRE_TOTAL_APPLICATION_COUNT,
    14_000
  );
